export enum WebhookEvents {
  CASES = "cases",
  EVIDENCE = "evidence",
  STORAGE = "storage",
  ACQUISITIONS = "acquisitions",
  TASKS = "tasks",
  DOCUMENTS = "documents",
  TIME_ENTRIES = "time_entries",
}
